import React from 'react'
import { CheckoutPage } from '../../model'
import { useIsDesignLanguage, DesignLanguage } from '@afterpaytouch/core'
import { ArcadeSummaryPage } from '../summary-arcade'
import { BronteSummaryPage } from '../summary-bronte'
import { SummaryNotificationProvider } from '../../component'
import { useIsAppleRetailOrder } from '../../state/checkout/hooks'
import { AppleRetailSummaryPage } from '../summary-apple-retail'
import { useIsConsumerLendingOrder, useIsPayMonthlySummaryRedesignEnabled } from '../../state/consumerLending/hooks'
import { useTriggerSummaryExperimentExposure } from '../../state/experiments/hooks'
import { PayMonthlySummaryPage } from '../summary-pay-monthly'
import { PayMonthlySummaryRedesignedPage } from '../summary-pay-monthly-redesign'
import { useAutoRememberMeIssuanceToast } from '../../component/AutoRememberMeIssuanceToast'

export const SummaryPage: CheckoutPage = () => {
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)
  const isAppleRetailOrder = useIsAppleRetailOrder()
  const isConsumerLendingOrder = useIsConsumerLendingOrder()
  const isPayMonthlySummaryRedesignEnabled = useIsPayMonthlySummaryRedesignEnabled()

  // CASHDAP-3379: the Pay Monthly summary redesign experiment exposure fires on summary VIEW (here)
  // rather than at login — the metric is summary-page drop-off. Self-gated to PCL orders, both arms.
  useTriggerSummaryExperimentExposure()

  // CASHDAP-3292: first-time remember-me issuance toast — mounted on the variant switcher so every
  // summary variant is covered. Self-gated on the one-shot mint signal (only set when a remember-me
  // session was actually minted this visit), so it's a no-op for everyone else.
  useAutoRememberMeIssuanceToast()

  let SummaryComponent = BronteSummaryPage

  if (isAppleRetailOrder) {
    SummaryComponent = AppleRetailSummaryPage
  } else if (isConsumerLendingOrder) {
    // CASHDAP-3090: gate the redesigned PM summary behind `checkout-pay-monthly-summary-redesign`.
    SummaryComponent = isPayMonthlySummaryRedesignEnabled ? PayMonthlySummaryRedesignedPage : PayMonthlySummaryPage
  } else if (isArcadeDesignLanguage) {
    SummaryComponent = ArcadeSummaryPage
  }

  // TODO: Fix rerender flashing between diff summary component causing Arcade Summary toast to show up during manual page refresh, useIsAppleRetailOrder flag value should cache

  return (
    <SummaryNotificationProvider>
      <SummaryComponent />
    </SummaryNotificationProvider>
  )
}
